'use client';

import { parseAsBoolean, useQueryState } from 'nuqs';
import { useEffect } from 'react';

interface CheckoutCompleteHandlerProps {
  onCheckoutComplete: (isComplete: boolean) => void;
}

export function CheckoutCompleteHandler({
  onCheckoutComplete,
}: CheckoutCompleteHandlerProps) {
  const [checkoutComplete] = useQueryState('checkout_complete', parseAsBoolean);

  useEffect(() => {
    onCheckoutComplete(checkoutComplete || false);
  }, [checkoutComplete, onCheckoutComplete]);

  return null;
}
